<template>
    <div class="table-header-actions-list">
        <transition name="fade" mode="out-in">
            <b-button-toolbar key-nav aria-label="Управление выбранными элементами"
                              v-if="Array.isArray(actions) && actions.length && show">
                <b-button-group size="sm" class="mx-1">
                    <template v-if="actions.length <= collapseCount">
                        <b-button variant="light"
                                  size="sm"
                                  v-for="action in actions"
                                  :key="action.name"
                                  v-if="!action.disabled"
                                  @click="doAction(action)">
                            <i v-if="windowWidth < 1024" class="far " :class="'fa-' + action.icon"></i>
                            {{windowWidth >= 1024 ? action.title : ''}}
                        </b-button>
                    </template>
                    <template v-else>
                        <b-button variant="light"
                                  size="sm"
                                  v-for="key in collapseCount"
                                  :key="actions[key-1].name"
                                  v-if="!actions[key-1].disabled"
                                  @click="doAction(actions[key-1])">
                            <i v-if="windowWidth < 1024" class="far " :class="'fa-' + actions[key-1].icon"></i>
                            {{windowWidth >= 1024 ? actions[key-1].title : ''}}
                        </b-button>
                        <b-dropdown text="Еще" size="sm" variant="light" no-caret>
                            <template v-slot:button-content>
                                <i class="fas fa-ellipsis-v"></i>
                            </template>
                            <b-dropdown-item v-for="key in (actions.length - collapseCount)"
                                             :key="actions[key+collapseCount-1].name"
                                             @click="doAction(actions[key+collapseCount-1])">
<!--                                <i class="far " :class="'fa-' + actions[key+collapseCount-1].icon"></i>-->
                                {{actions[key+collapseCount-1].title}}
                            </b-dropdown-item>
                        </b-dropdown>
                    </template>
                </b-button-group>
            </b-button-toolbar>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "ActionsToolbar",
        props: {
            actions: null,
            windowWidth: {
                type: [Number, String, null],
                default: 1024
            },
            show: {
                type: [Boolean, Number, null],
                default: true
            },
            collapseCount: {
                type: [Number, null],
                default: 3
            },
        },
        methods: {
            doAction(action) {
                this.$emit('action', action)
            }
        }
    }
</script>

<style scoped>

</style>